import { React, Fragment, useState, useEffect, useRef } from "react"
import Header from "../components/Header"
import SearchBox from "../components/search/SearchBox"
import { useDispatch, useSelector } from "react-redux"
import FiltersSearch from "../components/search/FiltersSearch"
import FilesList from "../components/search/FilesList"
import ElementsListSearch from "../components/search/ElementsListSearch"
import BackgroundImage from "../images/background.jpg"

//Redux actions
import { newSearchSearch } from "../actions/searchActions"
import {
	updateSearchHighlight,
	updateSearchSavedTags,
	updateSearchSavedTagsExclude,
	searchSavedTagsExclude,
	searchSavedTags,
	searchHighlightFilter,
} from "../actions/highlightActions"
// eslint-disable-next-line
import { showAlertAction, hideAlertAction } from "../actions/alertActions"
import { Redirect } from "react-router-dom"
import { requestSavedBuildConcepts } from "../actions/buildconceptActions"
import axios from "axios"
import SideMenu from "../components/menu/SideMenu"
import { sourceHelper } from "../helpers/sourceHelper"
import { requestSources } from "../actions/sourcesActions"
import { savedSearchLoadAll, saveInitSearchSagas } from "../actions/savedSearchActions"
import { requestCustomTags } from "../actions/customTagsActions"

const PageSearch = () => {
	/* ******************* REDUX STORE ******************* */
	//Access store state
	const dispatch = useDispatch()
	const isOnLoadDone = useRef(false)
	const cargando = useSelector((state) => state.search.loading)
	const alert = useSelector((state) => state.alert.alert)
	const currentSearchFilter = useSelector((state) => state.search.sourceFilter)
	const isUserLogedInt = useSelector((state) => state.authtentication.loggedIn)
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const tags = useSelector((state) => state.highlightFilter.searchTags)
	const tagsExclude = useSelector((state) => state.highlightFilter.searchTagsExclude)
	const sourceApi = useSelector((state) => state.sources.docs_sources)
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Show TermsList or ElementsList
	const [viewItemsBtn, setViewItemsBtn] = useState("list")
	const [lastSearchText, setLastSearchText] = useState("")
	const [lastCategories, setLastCategories] = useState([])
	// Search State
	// eslint-disable-next-line
	const [resultSearch, saveResultSearch] = useState()
	// Filter for elements list
	const [elementsFilter, saveElementsFilter] = useState({
		coloursFilter: "",
		date: "",
	})
	const [resetListView, setResetListView] = useState(false)

	const [filterList, setFilterList] = useState(sourceHelper.getFilter(sourceApi))
	const [updateFileTypes, setUpdateFiletypes] = useState()

	const [lastFilterList, setLastFilterList] = useState(sourceHelper.getFilter(sourceApi))

	const [requestNewDateSearch, setRequestNewDateSearch] = useState(false)
	// Filters Button
	const [filtersButton, setFiltersButton] = useState(highlightFilter)
	const [filterDate, setFilterDate] = useState()
	const [needToFilter, setNeedToFilter] = useState(false)
	const [border, setBorder] = useState(false)
	const [savedTags, setSavedTags] = useState(tags)
	const [savedTagsExclude, setSavedTagsExclude] = useState(tagsExclude)
	const [tempSearchText, setTempSearchText] = useState(null)
	const [tempCategories, setTempCategories] = useState(null)
	const [requestByFilters, setRequestByFilters] = useState(false)
	const [cancelRequestToken, setCancelRequestToken] = useState({ old: null, new: null })
	// Show / Hide popups
	const [popups, setPopups] = useState({
		showFilters: false,
		showFiletypes: false,
		showLoadConcepts: false,
	})

	const [fileTypesRefresh, setFileTypesRefresh] = useState(0)
	const [docCount, setDocCount] = useState(0)
	const [resetPage, setResetPage] = useState(false)

	const [currentTag, setCurrentTag] = useState("")
	const [currentSort, setCurrentSort] = useState("")
	/* ******************* END REACT STATES ******************* */

	/* ******************* USE-EFFECTS ******************* */

	//Loading original sources (File types)
	useEffect(() => {
		setFilterList(sourceHelper.getFilter(sourceApi))
	}, [sourceApi])

	useEffect(() => {
		//dispatch(updateSearchSavedTagsExclude(savedTagsExclude));
		dispatch(searchSavedTagsExclude(savedTagsExclude))
	}, [savedTagsExclude])

	useEffect(() => {
		//dispatch(updateSearchSavedTags(savedTags));
		dispatch(searchSavedTags(savedTags))
	}, [savedTags])

	useEffect(() => {
		//dispatch(updateSearchHighlight(filtersButton))
		dispatch(searchHighlightFilter(filtersButton))
	}, [filtersButton])

	useEffect(() => {
		//Render on init
		/*//Modify to use sagas 
        dispatch(getSavedBuildConceptsOnAPI());
        */
		// dispatch(requestSavedBuildConcepts());
		// dispatch(saveInitSearchSagas())
		// dispatch(requestSources())
		// if(!tagsApi.tags.length)
		//     dispatch(requestCustomTags())
		// // eslint-disable-next-line
	}, [])

	useEffect(() => {
		dispatch(saveInitSearchSagas())
		dispatch(requestSources())
		dispatch(requestCustomTags())
		dispatch(requestSavedBuildConcepts())
		setViewItemsBtn("list")
	}, [selectedBaseId])

	useEffect(() => {
		//active filters in search
		let activeInSearch = []

		Object.keys(currentSearchFilter).forEach(function (key) {
			if (currentSearchFilter[key] === true) {
				activeInSearch.push(key)
			}
		})

		let activeInFilter = []
		Object.keys(filterList).forEach(function (key) {
			if (filterList[key] === true) {
				activeInFilter.push(key)
			}
		})
		// Comentado porque siempre que se haga un cambio en el filtro se llama a la API
		// if(checker(activeInSearch,activeInFilter)===false){
		//     dispatch(newSearchSearch([lastSearchText],filtersObject,lastCategories));
		// }else{
		//     //Check if dates has changed
		//     if (requestNewDateSearch===true){
		//         dispatch(newSearchSearch([lastSearchText],filtersObject,lastCategories));
		//         setRequestNewDateSearch(false);
		//     }
		// }

		if (tempSearchText !== null || tempCategories !== null) {
			setRequestByFilters(true)
		}
	}, [requestNewDateSearch, filtersButton.fromDate, filtersButton.toDate])

	useEffect(() => {
		if (requestByFilters) {
			setRequestByFilters(false)
			submitSearch(tempSearchText, tempCategories)
		}
		return () => {
			if (cancelRequestToken.old !== null) {
				cancelRequestToken.old.cancel("axios request cancelled")
			}
		}
	}, [requestByFilters])

	useEffect(() => {
		if (viewItemsBtn === "list" && isOnLoadDone.current) {
			if (tempSearchText !== "" || tempCategories !== null) setRequestByFilters(false)
			setCurrentTag("")
			//clear filters
			setFiltersButton({ ...highlightFilter, fromDate: "", toDate: "" })
			saveElementsFilter({
				coloursFilter: "",
				date: "",
			})
			setFilterList(sourceHelper.getFilter(sourceApi))
			//submitSearch(tempSearchText, tempCategories);
			setResetListView(true)
		}
	}, [viewItemsBtn])

	useEffect(() => {
		if (isOnLoadDone.current) {
			if (resetListView) {
				setResetListView(false)
				submitSearch(tempSearchText, tempCategories)
			}
		} else {
			isOnLoadDone.current = true
		}
	}, [resetListView])

	// Add border class to input
	useEffect(() => {
		if (alert !== null) {
			setBorder(true)
		} else {
			setBorder(false)
		}
	}, [alert])
	useEffect(() => {
		if (Object.keys(sourceApi).length === 0 && Object.keys(lastFilterList).length === 0) {
			dispatch(requestSources())
			dispatch(requestCustomTags())
		}

		if (Object.keys(sourceApi).length > 0) {
			setFilterList(sourceHelper.getFilter(sourceApi))
			setLastFilterList(sourceHelper.getFilter(sourceApi))
		}
	}, [sourceApi])
	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	/* Send a search to Api. */
	//Submit Search
	const submitSearch = (searchText, categories) => {
		if (viewItemsBtn === "list") {
			try {
				let location = "search"
				setTempSearchText(searchText)
				setTempCategories(categories)
				//As per new_api chnage we require IDs
				const conceptsIds = categories.map((category) => category.id)
				//Validar y comprobar si nom hay errores

				//Hide alert
				dispatch(hideAlertAction())
				//Send to API
				//Get date filter
				let searchFilters = { ...filterList, datesFilter: {} }
				//let searchFilters={...filterList, datesFilter: {fromData: filtersButton.fromDate, toDate: filtersButton.toDate}};
				setLastSearchText(searchText)
				setLastCategories(categories)

				setCancelRequestToken({ old: cancelRequestToken.new, new: axios.CancelToken.source() })
				dispatch(newSearchSearch(searchText, filtersObject, conceptsIds, cancelRequestToken.new, location, currentTag))
				setResetPage(true)
			} catch (error) {
				console.log(error)
			}
		}
	}
	const createFilter = (filter) => {}

	const applyFilterSource = () => {
		// if (tempSearchText !== null || tempCategories !== null){
		setRequestByFilters(true)
		// }
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	let checker = (arr, target) => target.every((v) => arr.includes(v))
	const filtersObject = { ...filtersButton, ...filterList }
	/* ******************* END VARIABLES ******************* */

	try {
		document.body.style.backgroundImage = "none"
		document.body.classList.remove("newLoginPage")
	} catch (e) {}

	/* ******************* TEST File Types ******************* */
	//    console.log('Start test:');
	//    console.log(filtersObject);
	//    console.log(sourceApi);
	//    if (sourceApi.hasOwnProperty('sources')){
	//     sourceApi.sources.forEach(function(key, value){
	//         if (filtersObject.hasOwnProperty(key)){
	//             console.log(filtersObject[key]);
	//         }
	//     })};
	//    console.log('End test;');
	/* ******************* END TEST File Types ******************* */

	return (
		<Fragment>
			{isUserLogedInt ? null : <Redirect to={{ pathname: "/", state: "" }} />}
			<div className="d-flex">
				<SideMenu />
				<div className="container-xxl" id="contenido_principal" data-testid="contenido_principal">
					<div id="hero" className="hero">
						<div className="content" data-testid="search_page">
							<Header section="Terms" page="Search" />
							<SearchBox
								createSearch={submitSearch}
								border={border}
								setBorder={setBorder}
								popups={popups}
								setPopups={setPopups}
								setUpdateFiletypes={setUpdateFiletypes}
								setFilterList={setFilterList}
								filterList={filterList}
								setFileTypesRefresh={setFileTypesRefresh}
								docCount={docCount}
							/>
							{alert && alert.type !== "modal" ? <p className={alert.class}>{alert.msg}</p> : null}

							<FiltersSearch
								viewItemsBtn={viewItemsBtn}
								setViewItemsBtn={setViewItemsBtn}
								elementsFilter={elementsFilter}
								saveElementsFilter={saveElementsFilter}
								filterList={filterList}
								setFilterList={setFilterList}
								createFilter={createFilter}
								filtersButton={filtersButton}
								setFiltersButton={setFiltersButton}
								setFilterDate={setFilterDate}
								filterDate={filterDate}
								setRequestNewDateSearch={setRequestNewDateSearch}
								setNeedToFilter={setNeedToFilter}
								savedTags={savedTags}
								setSavedTags={setSavedTags}
								savedTagsExclude={savedTagsExclude}
								setSavedTagsExclude={setSavedTagsExclude}
								applyFilterSource={applyFilterSource}
								updateFileTypes={updateFileTypes}
								fileTypesRefresh={fileTypesRefresh}
								setFileTypesRefresh={setFileTypesRefresh}
								setDocCount={setDocCount}
								tagsList={tagsApi}
								setCurrentTag={setCurrentTag}
								setCurrentSort={setCurrentSort}
								currentSort={currentSort}
							/>

							{cargando ? (
								<div className="col-12 d-flex justify-content-center mt-5 mb-5">
									<div className="d-flex align-items-center alert alert-warning">
										<strong className="loading">Loading...</strong>
										<div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
									</div>
								</div>
							) : null}
							{viewItemsBtn === "list" ? (
								<ElementsListSearch
									elementsFilter={elementsFilter}
									saveElementsFilter={saveElementsFilter}
									filtersButton={filtersButton}
									filterList={filterList}
									filterDate={filterDate}
									needToFilter={needToFilter}
									setNeedToFilter={setNeedToFilter}
									tagsList={tagsApi}
								/>
							) : null}

							{viewItemsBtn === "files" ? (
								<FilesList
									filtersButton={filtersButton}
									setFiltersButton={setFiltersButton}
									elementsFilter={elementsFilter}
									saveElementsFilter={saveElementsFilter}
									filterDate={filterDate}
									filterList={filterList}
									needToFilter={needToFilter}
									setNeedToFilter={setNeedToFilter}
									tagsList={tagsApi}
									setResetPage={setResetPage}
									resetPage={resetPage}
									submitSearch={submitSearch}
									requestByFilters={requestByFilters}
									currentTag={currentTag}
									currentSort={currentSort}
								/>
							) : null}
						</div>
						{/* 
                        <div className="overlay" style={{background: `url(${BackgroundImage})`}}/>
                        */}
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export default PageSearch
